export default __webpack_public_path__ + "static/media/file-plus.139c63e8.svg";